'use client'

import React, { FC, ReactElement } from 'react'
import styles from './Donate.module.css'
import ButtonGradientEpic from '@/components/button-gradient-epic'
import DonateModal from '@/components/donate/donate-modal'
import BitcoinIcon from '@/icons/bitcoin'
import { onKeyboardClick } from '@/utils/a11y/keyboard-click'

const Donate: FC = (_props): ReactElement => {
	const [donate, setDonate] = React.useState(false)
	const handleClose = React.useCallback(() => setDonate(false), [])
	const handeDonate = React.useCallback((evt: any) => {
		evt.preventDefault()
		evt.stopPropagation()
		setDonate(true)
	}, [])

	return (
		<div className={styles.root}>
			<div
				onClick={handeDonate}
				role="button"
				tabIndex={0}
				onKeyDown={onKeyboardClick(handeDonate)}
			>
				<ButtonGradientEpic className={styles.donateButton} type={'submit'}>
					<BitcoinIcon className={styles.icon} />
					Donate
				</ButtonGradientEpic>
			</div>
			<DonateModal open={donate} onClose={handleClose} />
		</div>
	)
}

export default Donate
